import appGlobalScript from '/home/xavier/workspace/Discovery/discovery-widgets/src/discovery.ts';
export const globalScripts = appGlobalScript;
